import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });

const ReturnInput = ({ v, readOnly, save }) => {
  const [val, setVal] = useState(v.return_date || "");
  const commit = () => {
    if (val === (v.return_date || "")) return;
    if (val && val < today()) { toast.error("La data di rientro non può essere passata"); setVal(v.return_date || ""); return; }
    save(v, val);
  };
  return (
    <Input type="date" min={today()} value={val} disabled={readOnly} onChange={(e) => setVal(e.target.value)} onBlur={commit}
      onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
      className={`h-8 w-36 text-xs ${v.return_date ? "border-blue-300 bg-blue-50" : ""}`} data-testid={`forecast-return-${v.id}`} />
  );
};

export const StoppedPanel = ({ items, rescue, onChanged, readOnly }) => {
  const save = async (v, date) => {
    try { await api.put(`/forecast/returns/${v.id}`, { date: date || null }); toast.success(date ? `${v.plate}: rientro previsto il ${new Date(date).toLocaleDateString("it-IT")}` : `${v.plate}: rientro tolto`); onChanged(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="h-fit rounded-xl border border-slate-200 bg-white" data-testid="forecast-stopped-panel">
      <div className="border-b px-4 py-3">
        <h3 className="font-semibold">Furgoni fermi · {items.length}</h3>
        <p className="text-xs text-slate-500">Indica la data presunta di rientro dalla manutenzione: da quel giorno il furgone conta nei rientri.{rescue > 0 && ` Rescue: ${rescue} (non contati come disponibili).`}</p>
      </div>
      <div className="max-h-[32rem] divide-y overflow-y-auto">
        {items.map((v) => (
          <div key={v.id} className="flex items-center gap-3 px-4 py-2.5" data-testid={`forecast-stopped-${v.id}`}>
            <div className="min-w-0 flex-1">
              <p className="text-sm"><span className="font-mono-num rounded border border-slate-300 px-1.5 py-0.5 text-xs font-semibold">{v.plate}</span> <span className="text-xs text-slate-500">{v.model}</span></p>
              <p className="mt-0.5 truncate text-xs text-slate-500">{[v.reason, v.workshop].filter(Boolean).join(" · ") || "Motivo non indicato"}</p>
            </div>
            <ReturnInput key={v.return_date || "none"} v={v} readOnly={readOnly} save={save} />
            {v.return_date && !readOnly && <button onClick={() => save(v, null)} className="text-slate-400 hover:text-rose-600" title="Togli rientro" data-testid={`forecast-return-clear-${v.id}`}><X className="h-4 w-4" /></button>}
          </div>
        ))}
        {!items.length && <p className="px-4 py-8 text-center text-sm text-slate-500">Nessun furgone fermo.</p>}
      </div>
    </section>
  );
};
